import React from "react";
import { Constants } from "../../../../common/constants";
import "../../../css/rc_number_input.scss";
import validUrl from "valid-url";
import { DashboardUtils } from "../dashboard_utils";

interface ImageUploaderFormProps {
	name?: string;
	initial_value: string;
	updateFunc: Function;
	do_not_update_initially?: boolean;
	disabled?: boolean;
	hide_header?: boolean;
}

interface ImageUploaderFormState {
	value: string;
	url: string;
	error: boolean;
}

export class ImageUploaderForm extends React.Component<
	ImageUploaderFormProps,
	ImageUploaderFormState
> {
	constructor(props) {
		super(props);

		this.state = {
			value: this.props.initial_value ? this.props.initial_value : "",
			url: this.props.initial_value,
			error: false,
		};

		this.handleChange = this.handleChange.bind(this);
	}

	// TODO: Storing redundant state on both this form and its parent, fix??
	handleChange(event) {
		const value = event.target.value;

		if (validUrl.isUri(value) && value.match(/https?/)) {
			this.setState({
				value,
				url: value,
				error: false,
			});

			this.props.updateFunc(value);
		} else {
			this.setState({
				value,
				url: null,
				error: value.length > 0,
			});

			this.props.updateFunc(null);
		}
	}

	render() {
		return (
			<div>
				{this.props.name && !this.props.hide_header &&
					DashboardUtils.CreateHeaderAndInfoButton(
						"Image",
						"The image that will display on the embed for this event. Image URLs must start with http:// or https://.",
						false,
						false,
						false,
						undefined,
						this.props.disabled
					)}
				<div className="control">
					<input
						className="input"
						placeholder={"Image URL"}
						type="text"
						value={this.state.value}
						onChange={this.handleChange}
						maxLength={Constants.IMAGE_URL_LIMIT}
						disabled={this.props.disabled}
					/>
					{this.state.url && (
						<img
							className="uploaded-image"
							src={this.state.url}
							onError={() => {
								this.setState({ error: true, url: null });
								// Don't call updateFunc(null) on load errors - preserve original value
							}}
						></img>
					)}
					{this.state.error && (
						<p className="error-note mt-4">{"Invalid Image URL"}</p>
					)}
				</div>
			</div>
		);
	}
}
